import { IconButton, IconProps, Menu, SxProps, useTheme } from "@mui/material";
import * as React from "react";

import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import MoreVertIcon from "@mui/icons-material/MoreVert";

export interface MoreMenuProps {
  sx?: SxProps;
  children?: React.ReactNode;
  direction?: "vertical" | "horiz";
  size?: IconProps["fontSize"];
  className?: string;
  fadeIn?: boolean;
}

export interface MoreMenuHandle {
  closeMenu: () => void;
}

const MoreMenu = React.forwardRef<any, MoreMenuProps>((props, ref) => {
  const [anchorMoreEl, setAnchorMoreEl] = React.useState<null | HTMLElement>(null);

  const handleMoreClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setAnchorMoreEl(e.currentTarget);
  };
  const handleMoreClose = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setAnchorMoreEl(null);
  };

  const theme = useTheme();

  const openMore = Boolean(anchorMoreEl);

  React.useImperativeHandle(ref, () => ({
    closeMenu: () => setAnchorMoreEl(null),
  }));

  return (
    <>
      <IconButton
        sx={{
          opacity: !props.fadeIn || openMore ? 1 : 0,
          transition: theme.transitions.create(["opacity"], {
            duration: theme.transitions.duration.shortest,
            easing: theme.transitions.easing.easeInOut,
          }),
          ...props.sx,
        }}
        aria-label="more"
        id="more-notification-button"
        aria-controls={openMore ? "more-notification-menu" : undefined}
        aria-expanded={openMore ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleMoreClick}
        className={props.className}
      >
        {props.direction === "vertical" ? (
          <MoreVertIcon sx={{ ...(openMore && { opacity: 1 }) }} fontSize={props.size || "medium"} />
        ) : (
          <MoreHorizIcon sx={{ ...(openMore && { opacity: 1 }) }} fontSize={props.size || "medium"} />
        )}
      </IconButton>
      <Menu
        id="more-notification-menu"
        MenuListProps={{
          "aria-labelledby": "more-notification-button",
        }}
        anchorEl={anchorMoreEl}
        open={openMore}
        onClose={handleMoreClose}
        anchorOrigin={{
          vertical: "center",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {props.children}
      </Menu>
    </>
  );
});

export default MoreMenu;
